<template>
    <el-dialog title="" :visible.sync="visible" @closed="dialogClosedHandle" :close-on-click-modal="false">
        <video class="video-player" :src="url" autoplay controls></video>
        <div class="phone-listen">
            <img class="phone-listen-pic" :src="require('@/assets/phone-listen2.png')" alt="">
        </div>
    </el-dialog>
</template>

<script>
import { Dialog } from 'element-ui'
export default {
    name: 'VideoPlayer',
    data(){
        return {
            visible: false,
            url: ''
        }
    },
    components: {
        'el-dialog': Dialog
    },
    methods: {
        dialogClosedHandle(){
            this.url = ''
            document.body.removeChild(this.$el)
        }
    }
}
</script>

<style lang="scss" scoped>
.el-dialog__wrapper{
    .phone-listen{
        position: absolute;
        top: 10px;
        left: 0;
        right: 0;
        width: 153px;
        height: 24px;
        margin: auto;
        .phone-listen-pic{
            width: 100%;
        }
    }
    .video-player{
        position: absolute;
        left: 10px;
        top: 10px;
        width: 290px;
        height: 607px;
        border: 2px solid #000000;
        background-color: #222427;
        border-radius: 43px;
    }
    >>> {
        .el-dialog{
            position: relative;
            width: 313px;
            height: 630px;
            background-color: rgba(0,0,0,0);
        }
        .el-dialog__body{
            position: relative;
            overflow: hidden;
            height: 100%;
            padding: 0;
            background: url(../../assets/phone-model2.png) no-repeat center/contain;
        }
        .el-dialog__header{
            position: absolute;
            top: 100%;
            width: 100%;
            padding: 0;
            .el-dialog__headerbtn{
                left: 0;
                right: 0;
                top: 23px;
                margin: auto;
                i{
                    padding: 0;
                    color: #fff;
                    font-size: 19px;
                    &:hover{
                        // color: #000;
                        background-color: rgba(0,0,0,0);
                    }
                }
            }
        }
    }
    video{
        width: 100%;
        height: 100%;
    }
}
</style>


// WEBPACK FOOTER //
// src/components/VideoPlayer/VideoPlayer.vue